// OUR BRANDS (/brands) — HELLO-K · ENJOY LIVE-K
// 디자인 시안 HTML을 그대로 옮긴 화면입니다. 문구·사진·구성은 시안과 같게 유지해 주세요.
import { useEffect, useRef, useState } from "react";
import { usePageMotion } from "../motion/usePageMotion";

const JUMPS = [
  ["hello", "HELLO-K"],
  ["enjoy", "ENJOY LIVE-K"],
];

export default function Brands() {
  const [active, setActive] = useState("hello");
  const mainRef = useRef(null);

  // 등장 효과(14번)와 제목 단어별 등장
  usePageMotion(mainRef, {
    split: ["#page-title", ".brand-copy h2", ".connect h2"],
    reveal: [".intro .eyebrow", ".intro-grid p", ".intro-foot", ".brand-card", ".connect .eyebrow", ".connect p", ".connect .contact-link"],
  });

  // 보조 메뉴: 화면에 가장 많이 보이는 브랜드 카드 표시
  useEffect(() => {
    if (!("IntersectionObserver" in window)) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        const seen = entries.filter((x) => x.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (seen) setActive(seen.target.id);
      },
      { rootMargin: "-15% 0px -42% 0px", threshold: [0, 0.2, 0.5] }
    );
    for (const [id] of JUMPS) {
      const node = document.getElementById(id);
      if (node) observer.observe(node);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="subnav">
        <div className="wrap">
          <div className="crumb"><b>05</b>OUR BRANDS</div>
          <nav className="jump" aria-label="브랜드 바로가기">
            {JUMPS.map(([id, label]) => (
              <a key={id} href={`#${id}`} className={active === id ? "active" : undefined} onClick={() => setActive(id)}>
                {label}
              </a>
            ))}
          </nav>
        </div>
      </div>
      <main ref={mainRef}>
        <section className="intro wrap" aria-labelledby="page-title">
          <div className="eyebrow">OUR BRANDS / INBA THAILAND</div>
          <div className="intro-grid">
            <h1 id="page-title">TWO BRANDS.<br /><span>ONE CONNECTION.</span></h1>
            <p>사람의 기회를 연결하는 플랫폼부터 브랜드의 시장 진출을 이끄는 라이브커머스까지. 두 개의 전문 플랫폼으로 한국과 태국의 가능성을 확장합니다.</p>
          </div>
          <div className="intro-foot"><span>BRAND PORTFOLIO · KOREA × THAILAND</span><strong>01 — 02</strong></div>
        </section>
        <section className="brands wrap" aria-label="INBA 브랜드">
          <div className="brand-grid">
            <article className="brand-card hello" id="hello" aria-labelledby="hello-title">
              <div className="brand-top"><span className="n">01 / HELLO-K</span><span>{"VISA & COMMUNITY"}</span></div>
              <div className="brand-logo-zone">
                <img className="hello-logo" src="/assets/img/brands/hello-k_logo.png" alt="Hello-K 공식 로고" />
              </div>
              <div className="brand-copy">
                <h2 id="hello-title">한국에서의 새로운 기회를 연결합니다.</h2>
                <p>태국인을 위한 한국 취업·비자 상담과 생활 정보, 커뮤니티를 연결하는 플랫폼입니다.</p>
              </div>
              <div className="brand-tags" aria-label="핵심 영역">
                <span>{"VISA & CAREER"}</span>
                <span>LIFE IN KOREA</span>
                <span>COMMUNITY</span>
              </div>
              <div className="brand-media hello-media" aria-label="Hello-K 서비스 소개 연출 이미지">
                <img className="hello-photo" src="/assets/img/brands/hello-k_ai-visual.jpg" alt="한국 생활과 취업 정보를 함께 찾아보는 두 청년의 연출 이미지" />
                <div className="hello-overlay">
                  <small>HELLO-K / VISA · CAREER · COMMUNITY</small>
                  <strong>YOUR KOREA JOURNEY</strong>
                </div>
              </div>
              <div className="brand-note">HELLO-K 브랜드 소개용 AI 연출 이미지 · 실제 서비스 화면이 아닙니다.</div>
              <div className="brand-action">
                <span>hellok-th.com</span>
                <a className="brand-link" href="https://hellok-th.com/" target="_blank" rel="noopener noreferrer" aria-label="Hello-K 공식 사이트 방문 (새 창)">
                  {"VISIT WEBSITE "}
                  <i aria-hidden="true">↗</i>
                </a>
              </div>
            </article>
            <article className="brand-card live" id="enjoy" aria-labelledby="enjoy-title">
              <div className="brand-top"><span className="n">02 / ENJOY LIVE-K</span><span>{"CONTENT & COMMERCE"}</span></div>
              <div className="brand-logo-zone">
                <img className="live-logo" src="/assets/img/brands/enjoy-live-k_logo.jpg" alt="ENJOY LIVE-K 공식 로고" />
              </div>
              <div className="brand-copy">
                <h2 id="enjoy-title">콘텐츠를 실제 비즈니스로 연결합니다.</h2>
                <p>라이브커머스와 콘텐츠 제작, 인플루언서 네트워크를 통해 한국 브랜드와 태국 소비자를 연결합니다.</p>
              </div>
              <div className="brand-tags" aria-label="핵심 영역">
                <span>LIVE COMMERCE</span>
                <span>K-CONTENT</span>
                <span>DIGITAL MARKETING</span>
              </div>
              <div className="brand-media live-media">
                <img style={{ objectPosition: "62% 50%" }} src="/assets/img/photos/brands-livek.jpg" alt="Live-K 라이브 부스와 그린스크린 방송 세트 (2026 대구국제뷰티엑스포 태국관)" />
                <div className="live-overlay">
                  <small>{"ENJOY LIVE-K / CREATIVE & DIGITAL"}</small>
                  <strong>CONTENT IN MOTION.</strong>
                </div>
              </div>
              <div className="brand-note">Live-K 라이브 부스 실제 현장 · 2026 대구국제뷰티엑스포 태국관</div>
              <div className="brand-action">
                <span>enjoylivek.com</span>
                <a className="brand-link" href="https://enjoylivek.com/" target="_blank" rel="noopener noreferrer" aria-label="ENJOY LIVE-K 사이트 방문 (새 창)">
                  {"VISIT WEBSITE "}
                  <i aria-hidden="true">↗</i>
                </a>
              </div>
            </article>
          </div>
        </section>
        <section className="connect">
          <div className="wrap connect-inner">
            <div>
              <div className="eyebrow">INBA / BUSINESS CONNECTION</div>
              <h2>From connection to execution.</h2>
              <p>브랜드의 가능성을 현장에서 실현하는 INBA Thailand의 사업을 살펴보세요.</p>
            </div>
            <a href="/business" className="contact-link">{"EXPLORE OUR BUSINESS "}<span aria-hidden="true">↗</span></a>
          </div>
        </section>
      </main>
    </>
  );
}
